/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Instamouse API
 * REST API for Instamouse: launch, fork, and share browser-streamed xpra desktop machines. Generated client lives in the frontend (orval).
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ErrorResponse,
  MyProfileResponseResponse,
  UpdateMyProfile200,
  UpdateMyProfileBody,
  UserProfileResponseResponse
} from '../../model'
import { customFetch } from '../../../mutator/custom-fetch';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const getMyProfile = (
    
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<MyProfileResponseResponse>(
      {url: `/api/v1/users/me/profile`, method: 'GET', signal
    },
      options);
    }
  

export const getGetMyProfileQueryKey = () => {
    return [`/api/v1/users/me/profile`] as const;
    }

    
export const getGetMyProfileQueryOptions = <TData = Awaited<ReturnType<typeof getMyProfile>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyProfile>>> = ({ signal }) => getMyProfile(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getMyProfile>>>
export type GetMyProfileQueryError = ErrorResponse

export const useGetMyProfile = <TData = Awaited<ReturnType<typeof getMyProfile>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMyProfileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateMyProfile = (
    updateMyProfileBody: UpdateMyProfileBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<UpdateMyProfile200>(
      {url: `/api/v1/users/me/profile`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMyProfileBody
    },
      options);
    }
  


export const getUpdateMyProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyProfile>>, TError,{data: UpdateMyProfileBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMyProfile>>, TError,{data: UpdateMyProfileBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMyProfile>>, {data: UpdateMyProfileBody}> = (props) => {
          const {data} = props ?? {};

          return  updateMyProfile(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMyProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyProfile>>>
    export type UpdateMyProfileMutationBody = UpdateMyProfileBody
    export type UpdateMyProfileMutationError = unknown

    export const useUpdateMyProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyProfile>>, TError,{data: UpdateMyProfileBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateMyProfile>>,
        TError,
        {data: UpdateMyProfileBody},
        TContext
      > => {

      const mutationOptions = getUpdateMyProfileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getUserProfile = (
    username: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<UserProfileResponseResponse>(
      {url: `/api/v1/users/${username}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserProfileQueryKey = (username: string,) => {
    return [`/api/v1/users/${username}`] as const;
    }

    
export const getGetUserProfileQueryOptions = <TData = Awaited<ReturnType<typeof getUserProfile>>, TError = ErrorResponse>(username: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserProfileQueryKey(username);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserProfile>>> = ({ signal }) => getUserProfile(username, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(username), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getUserProfile>>>
export type GetUserProfileQueryError = ErrorResponse

export const useGetUserProfile = <TData = Awaited<ReturnType<typeof getUserProfile>>, TError = ErrorResponse>(
 username: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserProfileQueryOptions(username,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



